// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".zoomIn[data-v-69bff00f] {\n  -webkit-animation: zoomIn 0.5s;\n          animation: zoomIn 0.5s;\n}\n.email[data-v-69bff00f] {\n  display: block;\n  width: 150px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}", ""]);
// Exports
module.exports = exports;
